package fr.frux.shared.data.notification

import dev.zacsweers.metro.ContributesBinding
import dev.zacsweers.metro.Inject
import dev.zacsweers.metro.SingleIn
import fr.frux.core.common.di.AppScope
import fr.frux.shared.domain.notification.NotificationBadgeStore
import fr.frux.shared.domain.repository.NotificationRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

/**
 * Implémentation du compteur de notifications non lues (#225 P0), même patron que
 * [fr.frux.shared.data.favorites.FavoritesStoreImpl].
 *
 * Une page minimale ([UNREAD_PROBE_LIMIT] = 1) suffit : l'enveloppe [fr.frux.shared.domain.model.NotificationPage]
 * porte `unreadCount` à chaque appel, pas seulement pour la page demandée (contrat serveur, cf.
 * `NotificationListResponse`).
 */
@ContributesBinding(AppScope::class)
@SingleIn(AppScope::class)
@Inject
class NotificationBadgeStoreImpl(
    private val notificationRepository: NotificationRepository,
) : NotificationBadgeStore {
    private val _unreadCount = MutableStateFlow(0)
    override val unreadCount: StateFlow<Int> = _unreadCount.asStateFlow()

    override suspend fun refresh(): Result<Unit> =
        notificationRepository.getNotifications(limit = UNREAD_PROBE_LIMIT).map { page ->
            _unreadCount.value = page.unreadCount
        }

    override fun clear() {
        _unreadCount.value = 0
    }

    companion object {
        private const val UNREAD_PROBE_LIMIT = 1
    }
}
